import React from 'react';
import { Globe, CheckCircle } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Link } from 'react-router-dom';

const CO2NeutralWeb = () => {
  const { t, currentLanguage } = useLanguage();

  return (
    <section className="min-h-screen bg-neutral-50 py-12">
      <div className="container-custom max-w-3xl mx-auto">
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
          <div className="flex items-center gap-4 mb-6">
            <Globe className="h-10 w-10 text-primary-500" />
            <h1 className="text-2xl md:text-3xl font-bold text-primary-700">{t('service-co2-web')}</h1>
          </div>
          <p className="text-lg text-neutral-700 mb-6">
            {t('service-co2-web-desc')}
          </p>
          <ul className="space-y-3 mb-8">
            <li className="flex items-center gap-2 text-green-700 font-medium">
              <CheckCircle className="h-5 w-5 text-primary-500" /> {t('service-co2-web-feature-1')}
            </li>
            <li className="flex items-center gap-2 text-green-700 font-medium">
              <CheckCircle className="h-5 w-5 text-primary-500" /> {t('service-co2-web-feature-2')}
            </li>
            <li className="flex items-center gap-2 text-green-700 font-medium">
              <CheckCircle className="h-5 w-5 text-primary-500" /> {t('service-co2-web-feature-3')}
            </li>
            <li className="flex items-center gap-2 text-green-700 font-medium">
              <CheckCircle className="h-5 w-5 text-primary-500" /> {t('service-co2-web-feature-4')}
            </li>
          </ul>
          <div className="flex flex-col md:flex-row gap-4">
            <Link to={`/${currentLanguage}/contact`} className="btn-primary text-center">{t('form-submit')}</Link>
            <Link to={`/${currentLanguage}`} className="btn-secondary text-center">{t('back-to-home')}</Link>
          </div>
        </div>
        <div className="bg-primary-50 rounded-xl p-6 text-primary-800 text-center font-semibold">
          {t('service-co2-web-desc')}
        </div>
      </div>
    </section>
  );
};

export default CO2NeutralWeb; 